const STACKED_BAR_GAP = 1;

export const StackedBarShape = ({
  x,
  y,
  width,
  height,
  fill,
}: {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  fill?: string;
}) => {
  if (!height || height <= STACKED_BAR_GAP) return <></>;

  return <rect x={x} y={(y ?? 0) + STACKED_BAR_GAP} width={width} height={height - STACKED_BAR_GAP} fill={fill} />;
};
